import { newPrintJob } from '../../actions/print';
import { selectPrintJob } from '../../selectors/print';
import connect from '../connect';
import PrintDialog from './print_dialog.ui.jsx';
import { routeToContentPage } from '../../actions/route';

const mapStateToProps = (state, props) => ({
    rootState: state,
    selectPrintJob: jobId => selectPrintJob(state, jobId) || {},
});

export default connect(
    mapStateToProps,
    {
        newPrintJob,
        routeToContentPage,
    },
    null,
    { pure: false }
)(PrintDialog);



// WEBPACK FOOTER //
// ./src/components/engage_reader/print_dialog.jsx